import React from "react";
import {
  ArrayInput,
  FormDataConsumer,
  ReferenceInput,
  required,
  SelectInput,
  SimpleFormIterator,
  DateInput,
} from "react-admin";
import { Grid } from "@mui/material";
import { InternshipPlanScheduleTypes } from "utils/constants";
import { graduationRequests } from "api/graduationApi";
import { settings } from "app";
import CustomTimeOnlyInput from "server/components/Fields/CustomTimeOnlyInput";
import sessionExamsHelper from "components/AcademicYears/Exams/helper";

const EditForm = ({ filters }) => {
  const planId = filters?.planId || "";

  return (
    <>
      <Grid
        container
        spacing={2}
      >
        {planId && (
          <Grid
            item
            xs={12}
            md={6}
          >
            <ReferenceInput
              source="disciplineId"
              reference={graduationRequests.getPlanDisciplinesSelect(planId)}
              filter={{ planScheduleType: InternshipPlanScheduleTypes.IndividualCycles }}
            >
              <SelectInput
                label="Дисциплина"
                validate={required()}
                optionText="nameBg"
              />
            </ReferenceInput>
          </Grid>
        )}

        <Grid
          item
          xs={12}
          md={3}
        >
          <DateInput
            source="fromDate"
            label="От дата"
            validate={required()}
          />
        </Grid>

        <Grid
          item
          xs={12}
          md={3}
        >
          <DateInput
            source="toDate"
            label="До дата"
            validate={required()}
          />
        </Grid>

        <Grid
          item
          xs={12}
        >
          <ArrayInput
            source="slots"
            label="Часови интервали"
            defaultValue={[{}]}
          >
            <SimpleFormIterator
              disableReordering
              disableClear
              inline
              sx={settings.style.iteratorWithoutGap}
            >
              <FormDataConsumer>
                {({ scopedFormData }) => (
                  <>
                    <Grid
                      item
                      xs={12}
                      md={3}
                    >
                      <CustomTimeOnlyInput
                        source="startTime"
                        label="Начало"
                        required={true}
                        validate={() =>
                          sessionExamsHelper.validateTimeSlots({
                            startTime: scopedFormData?.startTime,
                            endTime: scopedFormData?.endTime,
                          })
                        }
                      />
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      md={3}
                    >
                      <CustomTimeOnlyInput
                        source="endTime"
                        label="Край"
                        required={true}
                        validate={() =>
                          sessionExamsHelper.validateTimeSlots({
                            startTime: scopedFormData?.startTime,
                            endTime: scopedFormData?.endTime,
                          })
                        }
                      />
                    </Grid>
                  </>
                )}
              </FormDataConsumer>
            </SimpleFormIterator>
          </ArrayInput>
        </Grid>
      </Grid>
    </>
  );
};

export default EditForm;
